import React from "react";
import { Label } from "semantic-ui-react";
import PropertyPhoto from "./PropertyPhoto";

// The compact property-information header at the top of every Strategy
// property dashboard - shared by the Buyer page's current/expanded property
// and the Seller page's single property, so both read as the same product.
// Only ever displays facts that are actually known - never invents a
// missing bedroom/bathroom count, year built, etc.
export default function StrategyPropertyHeader({
  pic,
  street,
  unit,
  city,
  state,
  zipcode,
  facts, // array of strings already formatted by the caller, e.g. ["3 beds", "3 baths", "3,000 sqft"]
  propertyTypeLine, // e.g. "Single Family · Built 2018"
  currentPrice,
  isCurrent,
  isMobile,
}) {
  const cityStateZip = [city, state].filter(Boolean).join(", ") + (zipcode ? ` ${zipcode}` : "");

  return (
    <div
      style={{
        display: "flex",
        flexDirection: isMobile ? "column" : "row",
        alignItems: isMobile ? "flex-start" : "center",
        gap: "16px",
        background: "#fafbfc",
        borderRadius: "8px",
        padding: "14px 16px",
      }}
    >
      <PropertyPhoto pic={pic} width={isMobile ? 90 : 110} height={isMobile ? 68 : 82} />

      <div style={{ flex: "1 1 auto", minWidth: 0 }}>
        <div style={{ display: "flex", alignItems: "center", gap: "8px", flexWrap: "wrap" }}>
          <b style={{ fontSize: "1.05em" }}>{street}{unit ? ` ${unit}` : ""}</b>
          {isCurrent && <Label size="tiny" color="blue">Current Property</Label>}
        </div>
        {cityStateZip.trim() && <div className="text-grey" style={{ fontSize: "0.9em" }}>{cityStateZip}</div>}
        {facts && facts.length > 0 && (
          <div className="text-grey" style={{ fontSize: "0.9em", marginTop: "6px" }}>{facts.join(" · ")}</div>
        )}
        {propertyTypeLine && (
          <div className="text-grey" style={{ fontSize: "0.9em" }}>{propertyTypeLine}</div>
        )}
      </div>

      <div style={{ textAlign: isMobile ? "left" : "right", flexShrink: 0 }}>
        <div className="text-grey" style={{ fontSize: "0.78em" }}>Current list price</div>
        <div style={{ fontWeight: 700, fontSize: "1.1em" }}>{currentPrice || "Not provided"}</div>
      </div>
    </div>
  );
}
